import { createPropertySelectors, createSelector } from '@ngxs/store';
import { orderBy } from 'lodash';

import { TransactionLookupState } from './transaction-lookup.state';
import { TransactionLookupStateModel } from './transaction-lookup.state.model';

export class TransactionLookupSelectors {
  static slices = createPropertySelectors<TransactionLookupStateModel>(
    TransactionLookupState
  );

  static transactions = createSelector(
    [TransactionLookupSelectors.slices.transactions],
    (transactions) => transactions.data || []
  );

  static isLoading = createSelector(
    [TransactionLookupSelectors.slices.transactions],
    (transactions) => transactions.isProcessing
  );

  static isLoaded = createSelector(
    [TransactionLookupSelectors.slices.transactions],
    (transactions) => transactions.isLoaded
  );

  static getTransactions = createSelector(
    [TransactionLookupSelectors.transactions],
    (transactions) =>
      orderBy(transactions, ['pos_ticket_id', 'created_at'], ['desc', 'desc'])
  );

  static selectedTransactionId = createSelector(
    [TransactionLookupSelectors.slices.selectedTransaction],
    (selectedTransaction) => selectedTransaction
  );

  static getSelectedTransaction = createSelector(
    [
      TransactionLookupSelectors.selectedTransactionId,
      TransactionLookupSelectors.transactions
    ],
    (selectedTransactionId, transactions) =>
      selectedTransactionId &&
      transactions.find((i) => i.id === selectedTransactionId)
  );

  static originalTicket = createSelector(
    [TransactionLookupSelectors.slices.originalTicket],
    (originalTicket) => originalTicket
  );

  static refundTicket = createSelector(
    [TransactionLookupSelectors.slices.refundTicket],
    (refundTicket) => refundTicket
  );
}
